<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="flex items-center">
  <button 
    type="button" 
    @click="toggle"
    class="flex-shrink-0 mt-0.5 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    :class="{ 'self-start': alignButtonStart }"
    role="switch" 
    aria-checked="false"
  >

    <span class="sr-only">Use setting</span>
    <span aria-hidden="true" class="pointer-events-none absolute w-full h-full rounded-md"></span>
    
    <!-- Enabled: "bg-blue-600", Not Enabled: "bg-gray-200" -->
    <span 
      aria-hidden="true" 
      class="pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
      :class="[value ? 'bg-blue-600' : 'bg-gray-200']"
    ></span>
    
    <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
    <span 
      aria-hidden="true" 
      class="pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200"
      :class="[value ? 'translate-x-5' : 'translate-x-0']"
    ></span>

  </button>
  <span @click="labelClick" class="ml-3 text-sm font-medium text-gray-900" :class="$attrs.labelClass">
    <slot></slot>
  </span>
</div>

</template>

<script>
export default {
  props: {
    value: Boolean,
    labelClickEnabled: {
      type: Boolean,
      default: true
    },
    alignButtonStart: {
      default: true
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    },
    labelClick() {
      if (this.labelClickEnabled) this.toggle()
    }
  }
}
</script>